import React, { useContext, useState } from 'react';
import { CartContext } from '../context/CartContext';
import './RequestQuote.css';

const RequestQuote = () => {
  const { cartItems, updateCartItem, removeFromCart } = useContext(CartContext);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', comments: '' });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState('');

  const sizeOptions = [
    'Plugs', '10cm', '1-gallon', '2-gallon', '3-gallon', '5-gallon', '10-gallon'
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus('');

    const itemsList = cartItems.map(item => 
      `- ${item.name} | Size: ${item.size} | Qty: ${item.quantity}`
    ).join('\n');

    const message = `
Cart Items:
${itemsList}

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Comments: ${formData.comments}
    `.trim();

    const payload = {
      api_key: 'api-359669F6DC224EFD865964D917E622E6',
      to: ['info@peelsnativeplants.com'],
      sender: 'mail@peelsnativeplants.com',
      reply_to: 'info@peelsnativeplants.com',
      subject: 'New Request Quote Submission',
      text_body: message,
    };

    try {
      const res = await fetch('https://api.smtp2go.com/v3/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.data && data.data.succeeded) {
        setStatus('Quote request submitted successfully!');
        setFormData({ name: '', email: '', phone: '', comments: '' });
      } else {
        setStatus('Error submitting quote. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setStatus('Network error. Please try again.');
    }

    setSubmitting(false);
  };

  return (
    <div className="request-quote-page">
      <h2>Request a Quote</h2>

      {cartItems.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          <div className="quote-table">
            <div className="quote-header">
              <span className="col-name">Product</span>
              <span className="col-size">Size</span>
              <span className="col-qty">Qty</span>
              <span className="col-remove"></span>
            </div>

            {cartItems.map((item, idx) => (
              <div className="quote-row" key={idx}>
                <span className="col-name">{item.name}</span>
                <span className="col-size">
                  <select
                    value={item.size || ''}
                    onChange={(e) =>
                      updateCartItem(idx, { ...item, size: e.target.value })
                    }
                  >
                    <option value="" disabled>Select Size</option>
                    {sizeOptions.map((size, i) => (
                      <option key={i} value={size}>{size}</option>
                    ))}
                  </select>
                </span>
                <span className="col-qty">
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) =>
                      updateCartItem(idx, {
                        ...item,
                        quantity: Math.max(1, parseInt(e.target.value) || 1)
                      })
                    }
                  />
                </span>
                <span className="col-remove">
                  <button onClick={() => removeFromCart(idx)}>×</button>
                </span>
              </div>
            ))}
          </div>

          <form className="quote-form" onSubmit={handleSubmit}>
            <h3>Your Contact Info</h3>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Name" required />
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" required />
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" required />
            <textarea name="comments" value={formData.comments} onChange={handleChange} placeholder="Comments (optional)" rows="4"></textarea>
            <button type="submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit Quote Request'}
            </button>
            {status && <p className={`quote-status ${status.includes('success') ? 'success' : 'error'}`}>{status}</p>}
          </form>
        </>
      )}
    </div>
  );
};

export default RequestQuote;
